import { render, staticRenderFns } from "./Sistemas.vue?vue&type=template&id=694ec1ad"
import script from "./Sistemas.vue?vue&type=script&lang=js"
export * from "./Sistemas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports